import { DatePicker, Form, Select } from "antd";
import { useEffect, useState } from "react";
import dayjs from "dayjs";
import axiosInstance, { api } from "../common/api";
import { filterOption, requiredField } from "../common/common";
import DebounceSelect from "../common/DebounceSelect";

export default function AbsenceFields({ employee }) {
  const [types, setTypes] = useState([]);
  useEffect(() => {
    api.absenceType
      .list({ pageSize: 99999 })
      .then((data) => setTypes(data.data.map((x) => ({ label: x.name ?? x.id, value: x.id }))));
  }, []);
  return (
    <>
      <Form.Item label="Dipendente" name="employee" rules={[requiredField]}>
        <DebounceSelect
          labelInValue={false}
          minSize={1}
          fetchOptions={(query) =>
            axiosInstance
              .get("employee", { params: { query, pageSize: 9999 } })
              .then(({ data }) => data.data.map((x) => ({ label: x.fullName, value: x.id })))
          }
        />
      </Form.Item>
      <Form.Item label="Categoria assenza" name="type" rules={[requiredField]}>
        <Select options={types} showSearch filterOption={filterOption} />
      </Form.Item>
      <Form.Item
        label="Data"
        name="date"
        rules={[requiredField]}
        getValueProps={(value) => ({ value: value && dayjs(value) })}
        normalize={(value) => value && value.format("YYYY-MM-DD")}
      >
        <DatePicker format="DD-MM-YYYY" />
      </Form.Item>
    </>
  );
}
